module.exports = __webpack_public_path__ + "img/tuition-tutorial-04.047e4120.png";